import { render, staticRenderFns } from "./excellentCourses.vue?vue&type=template&id=85018d68&scoped=true"
import script from "./excellentCourses.vue?vue&type=script&lang=js"
export * from "./excellentCourses.vue?vue&type=script&lang=js"
import style0 from "./excellentCourses.vue?vue&type=style&index=0&id=85018d68&prod&lang=css"
import style1 from "./excellentCourses.vue?vue&type=style&index=1&id=85018d68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85018d68",
  null
  
)

export default component.exports